import React from 'react';
import SelectField from './../Form/SelectField';

const FormP1T18 = React.memo((props) => {
    return (
        <form action="">
            <hr />
            <SelectField
                required
                label="Location"
                value={props.schedulingCard}
                setFunction={props.setSchedulingCard}
                options={[
                    { value: 1, label: 'The Woodlands' },
                    { value: 2, label: 'Texas Medical Center' },
                    { value: 3, label: 'Facial Plastic Surgery' },
                    { value: 4, label: 'Pediatric ENT' },
                    { value: 5, label: 'Greater Heights' },
                    { value: 6, label: 'Southeast Houston' },
                ]}
            />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                    { value: '1500', label: '1500' },
                    { value: '2000', label: '2000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> ENT Online Scheduling Cards</div>
                <div className="mt-2">
                    <span className="label">Description:</span> This card promotes online scheduling and provides
                    patients three ways to schedule their next appointment.
                </div>
                <div className="description-list">
                    <span className="label">Specs:</span>
                    <ul>
                        <li>Flat: 2" x 3.5"</li>
                        <li>Stock: 100# Uncoated Cover</li>
                        <li>Printed: 4/4</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP1T18;
